import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const candidateChecksValuesApi = createApi({
  reducerPath: 'candidateChecksValuesApi',
  baseQuery: createBaseQuery('candidates_checks_values'),
  endpoints: builder => ({
    rejectCandidateChecksValues: builder.mutation({
      query: ({ candidate_id, rejected_fields }) => ({
        url: `/candidate/${candidate_id}`,
        method: 'DELETE',
        body: { rejected_fields },
      }),
      transformResponse: ({ result }) => result,
    }),
    updateCandidateChecksValues: builder.mutation({
      query: ({ candidate_id, values }) => ({
        url: `/candidate/${candidate_id}`,
        method: 'PUT',
        body: { values },
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useRejectCandidateChecksValuesMutation, useUpdateCandidateChecksValuesMutation } =
  candidateChecksValuesApi;
